<template>
    <slot />
</template>

<style lang="scss" scoped>

</style>
